import * as React from 'react';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IStore } from 'redux/IStore';
import { connect } from 'react-redux';
import { ITranslateProps } from 'models/common';
import { renderOfficeOpeningTimeReadOnly } from 'containers/Shop/Helpers';
import { fullPhoneNumber } from 'helpers/common';

interface IOwnProps {
	officeId: string;
}

interface IProps extends IOwnProps, Partial<ITranslateProps>, ReturnType<typeof mapStateToProps> {}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopCardOfficeDetailsComponent extends React.Component<IProps, {}> {
	public render() {
		const { t, office } = this.props;

		return (
			<>
				<h4 className="subtitle d-none d-lg-block">{t('User_ShopCard_Title_OpeningHours')}</h4>
				<div className="times d-flex flex-wrap">
					{new Array(7).fill(0).map((_, day) => renderOfficeOpeningTimeReadOnly(day, t, office))}
				</div>
				<h4 className="subtitle d-none d-lg-block">{t('Shop_ManageShop_Location_Title_Contact')}</h4>
				<div className="contact-container">
					<a className="address d-flex flex-row">
						<p className="p14 gray">A</p>
						<p className="p14">{office?.location}</p>
					</a>
					<a
						className="telephone d-flex flex-row"
						href={`tel:${fullPhoneNumber(t, office?.callingCodeKey, office?.phoneNumber.split(' ').join(''))}`}
					>
						<p className="p14 gray">T</p>
						<p className="p14">{fullPhoneNumber(t, office?.callingCodeKey, office?.phoneNumber)}</p>
					</a>
					<a className="email d-flex flex-row pointer" href={`mailto:${office?.email}`}>
						<p className="p14 gray">E</p>
						<p className="p14">{office?.email}</p>
					</a>
				</div>
			</>
		);
	}
}

const mapStateToProps = (state: IStore, ownProps: IOwnProps) => {
	return {
		office: (state.shopcard.shopcard?.offices || []).find((o) => o.id === ownProps.officeId),
	};
};

const ShopCardOfficeDetails = connect(mapStateToProps)(ShopCardOfficeDetailsComponent);

export { ShopCardOfficeDetails };
